"use client";

import type { ReactNode } from "react";

export function FinancialWorkPreparingStatus({
  title = "กำลังโหลด",
  description = "กรุณารอสักครู่",
  variant = "preparing",
  action,
}: {
  title?: string;
  description?: string;
  variant?: "preparing" | "failed";
  action?: ReactNode;
} = {}) {
  const failed = variant === "failed";
  return (
    <div className={`flex gap-3 ${failed ? "items-start" : "items-center"}`}>
      <div
        className={
          failed
            ? "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-aera-redlight"
            : "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-aera-warmcream"
        }
        aria-hidden
      >
        {failed ? (
          <span className="text-xl font-bold leading-none text-aera-red">!</span>
        ) : (
          <span className="flex items-center gap-0.5">
            <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-aera-charcoal [animation-delay:-0.3s]" />
            <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-aera-charcoal [animation-delay:-0.15s]" />
            <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-aera-charcoal" />
          </span>
        )}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-aera-charcoal">{title}</p>
        <p className="mt-0.5 text-sm text-aera-gray">{description}</p>
        {action ? <div className="mt-1">{action}</div> : null}
      </div>
    </div>
  );
}
